import { PageInfo } from '@/types'
import { useCallback, useEffect, useState } from 'react'
import { usePageInfo } from './usePageInfo'
import { useNavigate, useParams } from 'react-router'

interface Props {
  pageInfo: PageInfo | undefined
  basePath?: string
  onIndex?: boolean
}

export const useTable = ({ pageInfo, basePath, onIndex }: Props) => {
  const navigate = useNavigate()
  const { id } = useParams<'id'>()

  const { pageInfo: pageInfoRef } = usePageInfo({ pageInfo })
  const [openNew, setOpenNew] = useState(false)
  const [openShow, setOpenShow] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [resourceId, setResourceId] = useState<string | null>(null)

  const showShow = useCallback((id: string) => {
    if (onIndex && basePath) {
      navigate(`${basePath}/${id}`)
    } else {
      setResourceId(id)
    }
  }, [navigate, basePath, onIndex])

  const hideShow = useCallback(() => {
    if (onIndex && basePath) {
      navigate(basePath)
    } else {
      setResourceId(null)
    }
  }, [navigate, basePath, onIndex])

  useEffect(() => {
    if (resourceId) {
      setOpenShow(true)
    } else {
      setOpenShow(false)
    }
  }, [resourceId])

  useEffect(() => {
    if (!onIndex || !basePath) return

    if (id) {
      setResourceId(id)
    } else {
      setResourceId(null)
    }
  }, [id, onIndex, basePath, navigate])

  return {
    pageInfo: pageInfoRef,
    openNew, setOpenNew,
    openShow, setOpenShow,
    openEdit, setOpenEdit,
    openDelete, setOpenDelete,
    resourceId, setResourceId,
    showShow, hideShow
  }
}
